export const ASPECT_RATIOS = [{
  label: '9:16',
  value: 0.5625
},{
  label: '3:4',
  value: 0.75
},{
  label: '4:5',
  value: 0.8
},{
  label: '1:1',
  value: 1
}];

export const DEFAULT_MIN_HEIGHT = 600;
export const DEFAULT_EDITOR_WIDTH = 626;
export const DEFAULT_SCALE = 1;
export const DEFAULT_ASPECT_RATIO = 1;
